import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';
// import ReactCountryFlag from 'react-country-flag';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { Box } from '@mui/material';
import { Typography, Tooltip } from '@material-ui/core';
import { styled, keyframes } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import { lowerCase } from 'lodash';
import { _route, workingDaysBetweenDates } from '../../../utils';
import { useDispatch } from 'react-redux';
import { setUserInfoToRedux } from '../../auth/action';
import dayjs from 'dayjs';
import premiumicon from '../../../assets/images/premiumicon.png';

export default function MenuItems() {
  const dispatch = useDispatch();
  const profile = useSelector(({ auth }) => auth.store.profile ?? null);
  const { syncProgress } = useSelector(({ auth }) => auth.store);
  const { realm, org } = useSelector(({ auth }) => auth);
  // const [anchorEl, setAnchorEl] = useState(null);
  const [progressFetchCount, setProgressFetchCount] = useState(0);
  // const open = Boolean(anchorEl);
  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  const { storeType } = useSelector(({ auth }) => auth.store);

  const stripes = keyframes`
  from {
    background-position: 0 0;
  }
  to {
    background-position: 100% 100%;
  }
`;

  const BorderLinearProgress = styled(LinearProgress)(() => ({
    height: 10,
    borderRadius: 6,
    background: 'rgb(221 221 221)',
    [`& .${linearProgressClasses.bar}`]: {
      backgroundColor: 'rgb(169 147 255)',
      backgroundImage: `repeating-linear-gradient(
      226deg, 
      transparent, 
      transparent 0.6rem,
      #5A31FF 0.6rem,
      #5a31ff 1.2rem
    )`,
      backgroundSize: `200% 200%`,
      animation: `${stripes} 15s linear infinite`,
    },
  }));

  useEffect(() => {
    if (syncProgress < 100 && syncProgress > 0) {
      setTimeout(async () => {
        await setUserInfoToRedux(dispatch);
        setProgressFetchCount(progressFetchCount + 1);
      }, 30000);
    }
  }, [progressFetchCount]);

  if (syncProgress < 100 && syncProgress > 0) {
    return (
      <Link to={_route('store.storeReconnect', { realm })}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {profile?.countryCode && (
            <img
              style={{
                width: '34px',
                // height: '28px',
                marginRight: '8px',
                borderRadius: '2px',
                marginTop: '4px',
              }}
              src={`https://flagcdn.com/h20/${lowerCase(profile?.countryCode === 'UK' ? 'GB' : profile?.countryCode)}.png`}
            />
          )}
          <Tooltip
            title={
              <p
                style={{ padding: '0.2rem', color: '#fff', fontSize: '13px', textAlign: 'left' }}
              >{`Your store sync is in progress ${syncProgress}%`}</p>
            }
            arrow
          >
            <Box sx={{ flexGrow: 1, width: '100px' }}>
              <Typography style={{ margin: 0, fontSize: '13px', fontWeight: 500 }}>Syncing...</Typography>
              <BorderLinearProgress variant="determinate" value={syncProgress} />
            </Box>
          </Tooltip>
        </div>
      </Link>
    );
  }

  if (org?.trialEnabled && syncProgress === 100 && org?.showTrialDialog && storeType !== 'paid') {
    return (
      <div className="flexAlignCenter flexCenter">
        <Link to={_route('subscription.plans', { realm })}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {dayjs(org?.trialEndsOn).format('YYYYMMDD') === dayjs().format('YYYYMMDD') && (
              <>
                <div style={{ marginRight: '12px', color: 'rgb(241 67 55)', fontWeight: 600 }}>
                  Your free trial ends today
                </div>
                <div>
                  <Tooltip
                    title={
                      <>
                        <img src={premiumicon} style={{ width: '52px', marginTop: '14px' }} />
                        <p
                          style={{
                            padding: '0.2rem',
                            color: '#fff',
                            fontSize: '14px',
                            lineHeight: '20px',
                            textAlign: 'center',
                          }}
                        >
                          Ready to take the next step? Don't miss out! Get a personalized pricing quote to keep the momentum
                          going.
                        </p>
                      </>
                    }
                    arrow
                  >
                    <Button className="upgradeBtn">Upgrade Now</Button>
                  </Tooltip>
                </div>
              </>
            )}
            {dayjs(org?.trialEndsOn).format('YYYYMMDD') > dayjs().format('YYYYMMDD') && (
              <>
                <div style={{ marginRight: '12px', color: '#000000', fontWeight: 500 }}>
                  Don't miss out! Your trial ends in&nbsp;
                  {workingDaysBetweenDates(
                    dayjs().format('MM-DD-YYYY'),
                    dayjs(org?.trialEndsOn).format('MM-DD-YYYY'),
                    true,
                  )}{' '}
                  days
                </div>
                <div>
                  <Tooltip
                    title={
                      <>
                        <img src={premiumicon} style={{ width: '52px', marginTop: '14px' }} />
                        <p
                          style={{
                            padding: '0.2rem',
                            color: '#fff',
                            fontSize: '14px',
                            lineHeight: '20px',
                            textAlign: 'center',
                          }}
                        >
                          {`To continue enjoying full access to SellerGeni after  ${workingDaysBetweenDates(
                            dayjs().format('MM-DD-YYYY'),
                            dayjs(org?.trialEndsOn).format('MM-DD-YYYY'),
                            true,
                          )} days i.e, on  ${dayjs(org?.trialEndsOn).format(
                            'DD MMM YYYY',
                          )} consider upgrading to a paid plan.`}
                        </p>
                      </>
                    }
                    arrow
                  >
                    <Button className="upgradeBtn">Upgrade Now</Button>
                  </Tooltip>
                </div>
              </>
            )}
            {dayjs(org?.trialEndsOn).format('YYYYMMDD') < dayjs().format('YYYYMMDD') && (
              <>
                <div style={{ marginRight: '12px', color: 'rgb(241 67 55)', fontWeight: 600 }}>
                  Your trial expired on {dayjs(org?.trialEndsOn).format('DD MMM YYYY')}!
                </div>
                <div>
                  <Tooltip
                    title={
                      <>
                        <img src={premiumicon} style={{ width: '52px', marginTop: '14px' }} />
                        <p
                          style={{
                            padding: '0.2rem',
                            color: '#fff',
                            fontSize: '14px',
                            lineHeight: '20px',
                            textAlign: 'center',
                          }}
                        >
                          {' '}
                          We hope you enjoyed using SellerGeni! To continue keep using the tool and all its features,
                          consider upgrading to a paid plan.
                        </p>
                      </>
                    }
                    arrow
                  >
                    <Button className="upgradeBtn">Upgrade Now</Button>
                  </Tooltip>
                </div>
              </>
            )}
          </div>
        </Link>
        {/* {profile?.countryCode && (
          <Button
            id="demo-customized-button"
            aria-controls={open ? 'demo-customized-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            variant="contained"
            disableElevation
            onClick={handleClick}
            style={{
              background: '#fff',
              color: '#000',
              border: '1px solid #D0D5DD',
              boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
              borderRadius: '8px',
              fontWeight: 400,
              fontSize: '14px',
              lineHeight: '24px',
              padding: '6px 8px',
              cursor: 'auto',
            }}
          >
            <img
              style={{
                width: '32px',
                marginRight: '8px',
                borderRadius: '2px',
              }}
              src={`https://flagcdn.com/h20/${lowerCase(profile?.countryCode === 'UK' ? 'GB' : profile?.countryCode)}.png`}
            />
            {profile.countryCode}
          </Button>
        )} */}
      </div>
    );
  } else {
    return <></>;
  }
}
